import React from 'react';

import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/glyph/cross';

import { StaticBanner } from '@qality/common-components/src/atoms/StaticBanner';

import { CloseButtonWrapperStyled } from './ClosableBanner.styled';

type Props = {
  children: React.ReactNode;
  buttonProps: Pick<React.ComponentProps<typeof Button>, 'onClick'>;
  isClosed?: boolean;
  testId?: string;
};

export default function ClosableBanner({
  children,
  buttonProps,
  isClosed = false,
  testId = 'closable-banner',
}: Props): JSX.Element {
  if (isClosed) {
    return null;
  }

  return (
    <StaticBanner
      testId={testId}
      slots={{
        after: (
          <CloseButtonWrapperStyled>
            <Button
              testId={`${testId}-close-button`}
              appearance='subtle'
              iconBefore={<CrossIcon label='' />}
              {...buttonProps}
            />
          </CloseButtonWrapperStyled>
        ),
      }}
    >
      {children}
    </StaticBanner>
  );
}
